export enum InvoiceDateProcessingType {
    PROCESSEDAT = 1,
    WORKFLOWCOMPLETEDAT = 2,
    VOUCHERVALIDATEDAT = 3,
}